<template>
  <div class="container">
    <div class="card-content" v-if="cardItem">
      <div class="cancel-btn" @click="unbindCard">取消关联</div>
      <div class="my-card">
        <img class="bg-card" src="../../picture/img/bg-card.png" />
        <div class="card-title">充电卡</div>
        <div class="card-no">NO.{{ cardItem.cardPkId }}</div>
      </div>
    </div>

    <pi-no-list-data
      :isMore="false"
      :list="cardItem && cardItem.cardPkId ? [cardItem] : []"
      text="暂无关联电卡，如需关联请联系运营商"
    >
      <img src="../../picture/no-data-icon/card.png" class="no-list-icon" />
    </pi-no-list-data>
  </div>
</template>
<script>
import { getCardList, unbindCard } from "../../common/api";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
export default {
  name: "car-list",
  data() {
    return {
      cardItem: {},
    };
  },
  components: {
    [noListData.name]: noListData,
  },
  methods: {
    async getCardList() {
      let ret = await getCardList({});
      if (ret.status == 0) {
        let data = ret.data;
        let cardItem = null;
        
        for (let i in data) {
          if (data[i].status == 0) {
            cardItem = data[i];
          }
        }
        this.cardItem = cardItem;
      }
    },
    async unbindCard() {
      let ret = await unbindCard({ cardPkId: this.cardItem.cardPkId });
      if (ret.status == 0) {
        this.getCardList();
        this.$toast("取消成功");
        this.$common.goBack();
      }
    },
  },
  mounted() {
    this.getCardList();
  },
};
</script>
<style lang="less" scoped>
.card-content {
  padding: 0 0.2rem;
}
.cancel-btn {
  padding: 0.2rem 0;
  text-align: right;
  color: #14cc80;
  font-size: 0.28rem;
  line-height: 0.37rem;
}
.my-card {
  position: relative;
  height: 3.3rem;
}

.bg-card {
  width: 100%;
  height: 100%;
}
.card-title {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  font-size: 0.3rem;
  font-weight: 500;
  color: #ffffff;
  line-height: 0.42rem;
}
.card-no {
  position: absolute;
  bottom: 0.2rem;
  left: 0.4rem;
  font-size: 0.36rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 0.5rem;
}
</style>